import {TFunction} from 'i18next';

export const createGetRequiredOrOptionalFieldLabel =
  (t: TFunction) => (label: string, required: string | boolean | undefined) => {
    if (required) {
      return label;
    }
    return `${label} (${t('optional')})`;
  };
